import React from 'react';
import { compose, first } from '../../../util';
import { UsersProvider } from './users';
import useConfig from '../../../config';
import KeycloakAuthenticator from './adapters/keycloak';
import MockAuthenticator from './adapters/mock';

export const context = React.createContext({});

export function useAuthData() {
	return React.useContext(context) || {};
}

export function AuthDataProvider({children, value}) {
	return  <context.Provider value={value}>{children}</context.Provider>
}

const ADAPTERS = {
	mock:MockAuthenticator,
	keycloak:KeycloakAuthenticator
}

function getFirstActiveAdapter(config, enforce) {
	const r = first(
		Object.keys(ADAPTERS)
		.filter(k => config[k] && config[k].active !== false)
		.map(k => [ADAPTERS[k], {...config[k], enforce}])
	);
	return r;
}

export default function Auth({children, enforce, users}) {
	const { users:usersFromConfig, ...config } = useConfig('auth');
	return compose(		
		config && getFirstActiveAdapter(config, enforce),
		(usersFromConfig && users) && [UsersProvider, {...users}]
	)(children);
}